import './ChipStrip.css';

export interface Chip {
  label: string;
  value: string;
  active?: boolean;
}

interface ChipStripProps {
  chips: Chip[];
  onSelect?: (value: string) => void;
  className?: string;
}

export function ChipStrip({ chips, onSelect, className = '' }: ChipStripProps) {
  return (
    <div className={`chip-strip ${className}`.trim()} role="tablist">
      {chips.map((c) => (
        <button
          key={c.value}
          type="button"
          role="tab"
          aria-selected={c.active}
          data-active={c.active}
          className="chip"
          onClick={() => onSelect?.(c.value)}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
